import { Observable, of } from 'rxjs';
import { Injectable } from '@angular/core';
import { SseStreamService } from '@gea/digital-ui-lib';
@Injectable()
export class CustomSseStreamService extends SseStreamService {
  override connect() {}

  override get sseEventStream(): Observable<{
    source: string;
    type: string;
    payload: unknown;
  }> {
    return of(
      {} as {
        source: string;
        type: string;
        payload: unknown;
      },
    );
  }

  override disconnect() {}
}
